import React from "react";
import { CommandBarButton, ConfirmDialog, useDisclosure, useNotifications } from "sprint-common-web";

import { useCloudFileApi } from "../../../../../common/api/master-api/cloud-files/useCloudFileApi";
import { AuthorizationWrapper } from "../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../core/security/SprintAccessRight";

export const ClearCloudFilesButton: React.FC = () => {
    const { abandonAllCloudFiles, abandonOrphanedCloudFiles } = useCloudFileApi();
    const { success } = useNotifications();

    const {
        isOpen: isDeleteOrphanedDialogOpen,
        onOpen: openDeleteOrphanedDialog,
        onClose: closeDeleteOrphanedDialog
    } = useDisclosure();
    const {
        isOpen: isDeleteAllDialogOpen,
        onOpen: openDeleteAllDialog,
        onClose: closeDeleteAllDialog
    } = useDisclosure();

    const handleDeleteOrphaned = async () => {
        const response = await abandonOrphanedCloudFiles();
        closeDeleteOrphanedDialog();
        success(`${response.abandonedFilesCount} files are being removed from bucket`);
    };

    const handleDeleteAll = async () => {
        const response = await abandonAllCloudFiles();
        closeDeleteAllDialog();
        success(`Removing ${response.removingCloudFileIds.length} cloud files has started`);
    };

    const getMenuItems = () => {
        return [
            {
                text: "Remove orphaned files",
                icon: "Delete",
                onClick: openDeleteOrphanedDialog
            },
            {
                text: "Remove all files",
                icon: "Delete",
                onClick: openDeleteAllDialog
            }
        ];
    };

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.QcAdmin]}>
            <CommandBarButton text="Remove" icon="Delete" menuItems={getMenuItems()} />
            <ConfirmDialog
                title="Delete orphaned files form bucket"
                text="Are you sure you want to delete orphaned from bucket? This action is irreversible."
                hidden={!isDeleteOrphanedDialogOpen}
                confirm={{ onClick: handleDeleteOrphaned }}
                cancel={{ onClick: closeDeleteOrphanedDialog }}
            />
            <ConfirmDialog
                title="Delete all files"
                text="Are you sure you want to delete files all files? This action is irreversible."
                hidden={!isDeleteAllDialogOpen}
                confirm={{ onClick: handleDeleteAll }}
                cancel={{ onClick: closeDeleteAllDialog }}
            />
        </AuthorizationWrapper>
    );
};
